<!--
 * @Author: haranzhu
 * @Date: 2022-12-28 13:42:02
 * @LastEditTime: 2022-12-28 18:37:59
 * @LastEditors: haranzhu
 * @Description:
 * @FilePath: \cloud drive\src\components\prompts\ClipVideo.vue
-->
<template>
  <el-dialog
    :visible.sync="isIframeShow"
    width="600px"
    :title="currentData && currentData.name"
    :append-to-body="true"
    class="deleteDialog commonDialog"
    :close-on-click-modal="false"
    :before-close="closeClipIframe"
  >
    <div v-loading="loading" element-loading-background="rgba(36, 38, 40, 1)">
      <iframe
        :src="iframeUrl"
        ref="searchIframe"
        frameborder="0"
        class="searchIframe"
      ></iframe>
    </div>
  </el-dialog>
</template>
<script>
import Outil from '@/assets/js/utils.js'
export default {
  data () {
    return {
      iframeUrl: '',
      loading: true
    }
  },
  props: {
    isIframeShow: {
      type: Boolean,
      default: false
    },
    // 编辑文件信息
    currentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // iframe传参
    iframeData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    const session = Outil.getSession()
    const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
    const url = urlInfo.tvuSearchUrl
    this.iframeUrl = `${url}?session=${session}&iframe=true`
    // this.iframeUrl = `https://cc-ms-kry.tvunetworks.com:8081/iframe.html?session=${session}&iframe=true`
    this.$nextTick(() => {
      window.addEventListener('message', this.searchListener)
    })
  },
  methods: {
    // 传送所需参数
    iframeDataSet () {
      const iframeData = this.iframeData
      const message = {
        type: 'init',
        result: iframeData
      }
      this.$refs.searchIframe.contentWindow.postMessage(message, '*')
    },
    // iframe消息监听
    searchListener (e) {
      const { type, result } = e.data
      if (type === 'init') {
        this.iframeDataSet()
        this.loading = false
      } else if (type === 'event') {
        // Bus.$emit('refreshList')
        // this.closeClipIframe()
      } else if (type === 'error') {
        this.$message.error(result)
      }
    },
    // 关闭
    closeClipIframe () {
      this.$refs.searchIframe.contentWindow.postMessage({ type: 'close' }, '*')
      this.$emit('IframeShowChange', false)
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.searchListener)
  }
}
</script>
<style lang="less">
.GlobalStyle .commonDialog{
  .el-dialog .el-dialog__header {
    height: 65px;
    line-height: 65px;
    .el-dialog__title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 65px;
      width: 99%;
      padding-right: 5px;
    }
  }
  .el-dialog__body{
    padding: 0;
    .searchIframe{
      width: 500px;
      height: 550px;
      margin-left: 6px;
    }
  }
}
</style>
